import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'gateway.PremierRM.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'gateway.PremierRM.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'gateway.PremierRM.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'gateway.PremierRM.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    anErrorOccurred: {
        id: 'quoteandbind.PremierRM.wizard.error',
        defaultMessage: 'Something went wrong during this process.',
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.PremierRM.wizard.error.title',
        defaultMessage: 'Error',
    },
    saveQuoteError: {
        id: 'quoteandbind.PremierRM.wizard.Unable to quote',
        defaultMessage: 'Unable to quote',
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.PremierRM.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.',
    },
    wantToCancel:{
        id:'quoteandbind.RecMarProduct.wizard.step.Are you sure you want to cancel?',
        defaultMessage:"Want to Cancel?"
    }
});
